import router from "../router";

import {
  requestRegistFormat,
  requestUpdateFormat,
  requestFormatDetail,
  requestFormatList,
  requestDeleteFormat
} from "@/apis/format_api";

const state = {
  formatList: [],
  formatPage: null,
  formatPageTotal: 0,
  formatTotalElemtnts: 0
};

const getters = {
  getFormatList(state) {
    return state.formatList;
  },
  getFormatPage(state) {
    if (state.formatPage === null) {
      return 0;
    } else {
      return state.formatPage.pageNumber + 1;
    }
  },
  getFormatPageTotal(state) {
    return state.formatPageTotal;
  },
  getFormatTotalElements(state) {
    return state.formatTotalElemtnts;
  }
};

const mutations = {
  FORMAT_LIST(state, data) {
    state.formatList = data.resultFormatList;
    state.formatPage = data.page;
    state.formatPageTotal = data.pageTotal;
    state.formatTotalElemtnts = data.totalElemtnts;
  }
};

const actions = {
  // new
  async REQUEST_FORMAT_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestFormatList(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("FORMAT_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
